import type { AxiosError } from 'axios';

export function httpErrorMsgFactory(err: AxiosError): string {
	const status = err?.response?.status;
	switch (status) {
		case 400: {
			return 'http-errors.bad-request';
		}
		case 401: {
			return 'http-errors.unauthorized';
		}
		case 403: {
			return 'http-errors.forbidden';
		}
		case 404: {
			return 'http-errors.not-found';
		}
		case 417: {
			return 'http-errors.expectation-failed';
		}
		case 500: {
			return 'http-errors.internal-server-error';
		}
		case 503: {
			return 'http-errors.service-unavailable';
		}
		default: {
			return 'http-errors.default-error';
		}
	}
}
